import { render } from "./EventoPage.vue?vue&type=template&id=8aadf056&scoped=true"
import script from "./EventoPage.vue?vue&type=script&lang=js"
export * from "./EventoPage.vue?vue&type=script&lang=js"

import "./EventoPage.vue?vue&type=style&index=0&id=8aadf056&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8aadf056"]])

export default __exports__